import $ from "jquery";
import app from "./src/App";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Header
// Menu GSAP animation
const menuTL = gsap.timeline({ paused: true });
menuTL
  .fromTo(".header__helper", { right: "-100%" }, { right: 0, duration: 0.3 })
  .fromTo(".menu-item a span", { y: "100%" }, { y: 0, delay: 0.3 })
  .fromTo(".js-menu-item-animation", { y: "80px" }, { y: 0 }, "<")
  .fromTo(".right-helper", { opacity: 0 }, { opacity: 1 }, "<");

$("#header .menu-trigger").click(function () {
  const closeMenu = () => {
    menuTL.timeScale(1).reverse();
  };
  const openMenu = () => {
    menuTL.play();
  };

  $("body").hasClass("menu-open") ? closeMenu() : openMenu();
  $("body").toggleClass("menu-open");
});

// Hover menu items - photo
$(".menu-item a").mouseover(function () {
  let _this = $(this);
  let imagePlaceholder = $(".right-helper .dynamic");
  let imageContainer = $(".right-helper");

  imagePlaceholder.attr("src", _this.attr("title"));
  imageContainer.addClass("hovered");
});

$(".menu-item a").mouseout(function () {
  let imageContainer = $(".right-helper");
  imageContainer.removeClass("hovered");
});

// Fade in animation
$(".js-fade-in").each(function () {
  gsap.set(this, { opacity: 0, duration: 1 });

  gsap.to(this, {
    opacity: 1,
    duration: 1.5,
    scrollTrigger: {
      trigger: this,
      start: "top 80%",
      end: "bottom 80%",
      toggleActions: "play none none reverse",
    },
  });
});

// 100vh Fix
function setViewportProperty(doc) {
  let prevClientHeight;
  let customVar = "--vh";

  function handleResize() {
    var clientHeight = doc.clientHeight;
    if (clientHeight === prevClientHeight) return;
    requestAnimationFrame(function updateViewportHeight() {
      doc.style.setProperty(customVar, clientHeight * 0.01 + "px");
      prevClientHeight = clientHeight;
    });
  }

  handleResize();
  return handleResize;
}

window.addEventListener(
  "resize",
  setViewportProperty(document.documentElement),
);

// Cursor
const mm = gsap.matchMedia();
mm.add("(min-width : 768px)", function () {
  $(document).on("mousemove.cursor", (e) => {
    gsap.to(".ball", {
      duration: 0.5,
      left: e.clientX,
      top: e.clientY,
    });
  });
  return function () {
    $(document).off("mousemove.cursor");
  };
});
$("a, button").mouseover(function () {
  $(".ball svg circle").css("fill", "#2D2D2D");
  $(".ball").addClass("hovered");
});
$("a, button").mouseout(function () {
  $(".ball svg circle").css("fill", "transparent");
  $(".ball").removeClass("hovered");
});

mm.add("(max-width : 767px)", function () {
  $(".menu-container .menu > li:first-child > a").on("click.menu", (e) => {
    e.preventDefault();
    $(".sub-menu").slideToggle();
  });
  return function () {
    $(".menu-container .menu > li:first-child > a").off("click.menu");
  };
});

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

jQuery(document).ready(function($) {
  if (!document.cookie.includes('promo_popup_closed=1')) {
    $(".book_popup").removeClass("hidden");
  }
  $(".book_popup .popup_close").on("click", function(e) {
    e.preventDefault();
    $(".book_popup").fadeOut(300, function() {
      $(this).addClass("hidden");
    });
    const d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
    document.cookie = "promo_popup_closed=1; path=/; expires=" + d.toUTCString();
  });
});
